import { useI18n } from '../../i18n/I18nContext'
import { stateHeadlines } from '../../i18n/stateHeadlines'
import { useNetworkStatus } from '../../providers/NetworkStatusProvider'
import RecoveryShell from '../../components/ui/RecoveryShell'
import { Button } from '../../components/ui/Primitives'

export default function ServerErrorPage() {
    const { t, language } = useI18n()
    const { reportSuccess } = useNetworkStatus()
    return <RecoveryShell title={t('errorPage.serverError.title')} headline={stateHeadlines(language).error}>
        <Button onClick={() => { reportSuccess(); window.location.reload() }}>{t('errorPage.serverError.retry')}</Button>
    </RecoveryShell>
}
